import hmd_softlock_logo from 'url:/assets/hmd_softlock_logo.svg'
import React from 'react'
import { Button } from '../../genericComponents/Button'
import { useNavigate } from 'react-router'

export const RegistrationPage: React.FC = () => {
  const navigate = useNavigate()

  const handleChange = () => {
    void navigate('/login')
  }
  return (
    <div className="flex h-screen justify-center w-full">
      <div className="flex flex-col flex-wrap self-center w-[300px] md:w-[440px]">
        <img src={hmd_softlock_logo} alt="" className="mb-6 w-40" />

        <div className="font-semibold mt-6">Your email has been verified!</div>
        <p className="text-left mt-6">
          Use your email address and the temporary password you received to sign in.
        </p>

        <Button
          type="submit"
          onClick={handleChange}
          className="w-full bg-primaryButtonColor text-white mt-6"
        >
          Go to sign in
        </Button>
      </div>
    </div>
  )
}
